/**
 * Keeps the upsell card's image and savings badge on the chosen variant.
 *
 * The theme's own picker handler (cart-product-upsell.js) updates the hidden
 * variant id, the price and the compare-at price, and stops there. The two
 * things below are ours, so nothing was updating them: switching the rake to
 * Pink left a blue rake on the card, and the savings badge would have kept
 * quoting the previous variant's discount next to the new price.
 *
 * Both values are rendered into each <option> by the block, because they are
 * Liquid's to know -- the tile mapping and the percentage off come from the
 * product and its variants, not from anything this script can see. An option
 * that carries neither leaves both alone, which is what should happen for a
 * product whose options do not change the picture or the discount.
 *
 * Delegated from document because the drawer replaces its own innerHTML on
 * every cart change, which would throw away a listener bound to the card.
 */
(function () {
  var FILES = "https://cdn.shopify.com/s/files/1/0748/9886/6328/files/";

  function swapImage(card, tile) {
    var img = card.querySelector(".cart-upsell-card__image");
    if (!img || !tile) { return; }
    if (img.getAttribute("data-tile") === tile) { return; }

    var base = FILES + tile + ".webp";
    // ?width= first so the separator is "?" and not "&", which the CDN rejects
    img.setAttribute("srcset", base + "?width=60 60w, " + base + "?width=120 120w, "
                     + base + "?width=180 180w");
    img.setAttribute("src", base + "?width=120");
    // the framing rules key off data-tile, so it has to move with the image
    img.setAttribute("data-tile", tile);
  }

  function syncSave(card, text) {
    var badge = card.querySelector("[data-upsell-save]");
    if (!badge) { return; }
    var label = badge.querySelector("[data-upsell-save-text]");
    if (text) {
      if (label) { label.textContent = text; }
      badge.hidden = false;
    } else {
      // no discount on this variant: say nothing rather than "SAVE 0%"
      if (label) { label.textContent = ""; }
      badge.hidden = true;
    }
  }

  document.addEventListener("change", function (event) {
    var select = event.target && event.target.closest
      ? event.target.closest(".cart-upsell-card__variant")
      : null;
    if (!select) { return; }
    var card = select.closest(".cart-upsell-card");
    var option = select.options[select.selectedIndex];
    if (!card || !option) { return; }
    swapImage(card, option.getAttribute("data-chw-tile"));
    syncSave(card, option.getAttribute("data-chw-save"));
  });
})();
